<template>
  <div :class="fileUploaderContainerClass">
    <div class="title">
      {{
        type && required ? type + "*" : type || intl[$store.state.lang]["title"]
      }}
    </div>
    <div v-if="showInfo" class="update-info-container">
      <div>{{ intl[$store.state.lang]["file-formats"] }}</div>
      <div>{{ intl[$store.state.lang]["max-dim"] }}</div>
      <div>{{ intl[$store.state.lang]["max-file-number"] }}</div>
      <div>{{ intl[$store.state.lang]["title"] }}</div>
    </div>
    <div :id="'drag-and-drop-' + id" class="drag-and-drop">
      <file-pond
        name="test"
        ref="pond"
        :label-idle="intl[$store.state.lang]['drop-message']"
        allow-multiple="true"
        max-files="5"
        v-on:addfile="onAddFileCallback"
        v-on:removefile="onRemoveFileCallback"
        v-on:updatefiles="onUpdateFiles"
        imagePreviewHeight="100px"
        accepted-file-types="image/jpeg, image/png, image/gif, application/pdf"
        v-bind:files="selectedFiles"
      />
      <div :id="'attachment-error-message-' + id" class="attachment-error-message d-none">
        {{intl[$store.state.lang]["attachment-error"]}}<i class="bi bi-exclamation-circle"></i>
      </div>
      <div :id="'attachment-ok-message-'+this.id" class="attachment-ok-message d-none">
        Ok. <i class="bi bi-check-lg"></i>
      </div>
      <button
        v-if="useFileUploaderButton"
        class="btn btn-success"
        @click="onUpload"
      >
        {{ intl[$store.state.lang]["upload"] }}
      </button>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import { apiUrls } from "../../api/apiUrls";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);
export default {
    name: "fileUploader",
    mounted() {},
    components: {
      FilePond
    },
    props: {
        id: {
            type: Number,
            default: null
        },
        required: {
            type: Boolean,
            default: false
        },
        showInfo: {
            type: Boolean,
            default: true
        },
        showError: {
            type: Boolean,
            default: false
        },
        folderName: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        ticketId: {
            type: Number,
            default: null
        },
        extra_request_id:{
            type: Number,
            default: 0
        },
        onAddFileCallback:{
            type:Function,
            default: (error, file) => {console.log("File uploaded: ",file)}
        },
        onRemoveFileCallback:{
            type:Function,
            default: (error, file) => {console.log("File removed: ",file)}
        },
        onUpdateFilesCallback:{
            type:Function,
            default: (files) => {console.log("Files: ",files)}
        },
        useFileUploaderButton: {
            type: Boolean,
            default: true
        },
        setPaginaLoaderCallback: {
            type: Function,
            default: (value) => {console.log("FILE UPLOADER LOADER: ",value)},
        },

    },
    created() {

    },


    data: function () {
        return {
            fileUploaderLoader: false,
            intl: intl,
            selectedFiles: [],
            filePondFiles: []
        };
    },
    methods: {
      onUpdateFiles(files){
   
          if(this.filePondFiles.length !== files.length){
              if(this.required){
                  if(files.length === 0 && document.getElementById("drag-and-drop-"+this.id).classList.contains("all-ok")){
                      this.showErrorMessage()
                  }else if(files.length > 0 && document.getElementById("drag-and-drop-"+this.id).classList.contains("error-message")){
                      this.showGreenBorder()
                  }
              }
              this.filePondFiles = files
              this.onUpdateFilesCallback(files)

          }

      },

    showErrorMessage(){
        document.getElementById("drag-and-drop-"+this.id).classList.remove("all-ok");
        document.getElementById("attachment-error-message-"+this.id).classList.remove("d-none");
        if (!document.getElementById("drag-and-drop-"+this.id).classList.contains("error-message")) {
            document.getElementById("drag-and-drop-"+this.id).classList.add("error-message");
        }
        if (!document.getElementById("attachment-ok-message-"+this.id).classList.contains("d-none")) {
            document.getElementById("attachment-ok-message-"+this.id).classList.add("d-none");
        }
      },
      removeErrorMessage(){
        document.getElementById("drag-and-drop-"+this.id).classList.remove("error-message");
        if (!document.getElementById("attachment-error-message-"+this.id).classList.contains("d-none")) {
             document.getElementById("attachment-error-message-"+this.id).classList.add("d-none");
        }
        
         
      },
      showGreenBorder(){
        this.removeErrorMessage();
        if (!document.getElementById("drag-and-drop-"+this.id).classList.contains("all-ok")) {
            document.getElementById("drag-and-drop-"+this.id).classList.add("all-ok");
        }
        document.getElementById("attachment-ok-message-"+this.id).classList.remove("d-none");
        
        
      },

      




      onUpload: function(){
          const fd = new FormData();
          this.$refs.pond.getFiles().map((file) => {
              if(file.status === 2){
                fd.append("file[]",file.file)
              }

          })
         
          fd.append("type",this.type)
          fd.append("extra_request_id",this.extra_request_id)
          fd.append("ticket_id",this.ticketId)
          this.fileUploaderLoader = true
          axios
          .post(apiUrls["create_ticket_attachments"],fd)
          .then((response) => {
            this.fileUploaderLoader = false
          })
          .catch((error) => {
            this.fileUploaderLoader = false
          });


      }
    },
    watch: {
       fileUploaderLoader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        if(this.type){
                            this.setPaginaLoaderCallback({["fileUploaderLoader-"+this.type]: newValue})
                        }else{
                            this.setPaginaLoaderCallback({fileUploaderLoader: newValue})
                        }

                    }
                },
                immediate: true,
        },


    },
    computed: {
        fileUploaderContainerClass: function () {
            if(this.showError){
                return "file-uploader-container error"
            }else{
                return "file-uploader-container"
            }
        },
    },
};
</script>
